export const KpiCard = ({ label, value, sub, tone = "default", testId, className = "" }) => {
  const tones = {
    default: "border-slate-200",
    danger: "border-red-200 bg-red-50/40",
    warn: "border-amber-200 bg-amber-50/40",
    good: "border-emerald-200 bg-emerald-50/40",
  };
  return (
    <div className={`rounded-lg border bg-white p-5 transition-shadow hover:shadow-md rise ${tones[tone]} ${className}`} data-testid={testId}>
      <p className="text-[11px] font-mono uppercase tracking-widest text-slate-500">{label}</p>
      <p className="mt-2 text-2xl font-semibold tabular text-slate-900" data-testid={testId ? `${testId}-value` : undefined}>
        {value}
      </p>
      {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
    </div>
  );
};

export const Panel = ({ title, action, children, className = "", testId }) => (
  <section className={`scroll-mt-[calc(var(--onglets-h,3rem)+1rem)] rounded-lg border border-slate-200 bg-white rise ${className}`} data-testid={testId} data-section={typeof title === "string" ? title : undefined}>
    {title && (
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-3.5">
        <h2 className="text-sm font-semibold text-slate-900">{title}</h2>
        {action}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);
